package uz.ferro.erp.feature.salesperson.data

import uz.ferro.erp.api.suspendGet
import uz.ferro.erp.feature.salesperson.model.SalesPersonDto

object SalesPersonRepository {

    suspend fun getSalesPersons(): List<SalesPersonDto> {
        return suspendGet("sales/persons")
    }
}